import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend'; // Pour charger les fichiers JSON

i18n
  .use(Backend) // Utiliser le backend pour charger les fichiers
  .use(initReactI18next) // passe i18n à react-i18next
  .init({
    lng: localStorage.getItem('language') || 'fr', // langue par défaut
    fallbackLng: 'en', // langue de secours
    debug: true, // pour le débogage, à enlever en production
    interpolation: {
      escapeValue: false // React se charge de l'échappement
    },
    backend: {
      loadPath: '/assets/translations/translation_{{lng}}.json' // chemin vers les fichiers JSON
    }
  });

export default i18n;
